const semanticClassNames = {
  root: 'search-button',
  buttonLabel: 'search-button__label',
  buttonIcon: 'search-button__icon',
} as const;

export default semanticClassNames;
